module.exports = __webpack_public_path__ + "static/media/buyIcon.a1b3ab1a.svg";